function alignEventCalendarRows() {
  document.querySelectorAll('.event-calendar__grid').forEach(function (grid) {
    const cards = Array.from(grid.querySelectorAll('.event-calendar__card'));

    cards.forEach(function (card) {
      card.classList.remove('event-calendar__card--align-extra');
    });

    if (window.innerWidth < 750) return;

    const rows = {};

    cards.forEach(function (card) {
      const top = card.offsetTop;
      if (!rows[top]) rows[top] = [];
      rows[top].push(card);
    });

    Object.values(rows).forEach(function (rowCards) {
      const rowHasExtraInfo = rowCards.some(function (card) {
        return card.querySelector('.event-calendar__extra-info');
      });

      if (rowHasExtraInfo) {
        rowCards.forEach(function (card) {
          card.classList.add('event-calendar__card--align-extra');
        });
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', alignEventCalendarRows);
window.addEventListener('resize', alignEventCalendarRows);
window.addEventListener('load', alignEventCalendarRows);